import React from 'react';
import CustomerWorkspaceTabs from './CustomerWorkspaceTabs';
import './CustomerWorkspaceShell.css';

/** Presentation only: every read and command remains in the authorized host adapter. */
export default function CustomerWorkspaceShell({ name, company, email, phone, actions, view, onViewChange, children, compact = false }) {
  const initials = (name || 'Customer').trim().split(/\s+/).slice(0, 2).map(part => part[0]).join('').toUpperCase();
  return <section className={`customer-workspace-shell${compact ? ' customer-workspace-shell-compact' : ''}`} aria-label="Customer profile">
    <header className="customer-workspace-header">
      <span className="customer-workspace-avatar" aria-hidden="true">{initials}</span>
      <div className="customer-workspace-identity"><small>Customer profile</small><h2>{name || 'Customer'}</h2>
        <p>{[company, email, phone].filter(Boolean).join(' · ')}</p>
      </div>
      {actions && <div className="customer-workspace-actions">{actions}</div>}
    </header>
    <CustomerWorkspaceTabs value={view} onChange={onViewChange} />
    <div className="customer-workspace-content">{children}</div>
  </section>;
}
